import React from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';

interface SummaryTileProps {
    title: React.ReactNode;
    value: string | React.ReactNode;
    subtext?: string | React.ReactNode;
    footer?: string;
    isLoading?: boolean;
    extraContent?: React.ReactNode;
    containerSx?: SxProps<Theme>;
    className?: string;
    valueClassName?: string;
    cardClassName?: string;
    children?: React.ReactNode;
}

const SummaryTile: React.FC<SummaryTileProps> = ({
    title,
    value,
    subtext,
    footer,
    isLoading = false,
    extraContent,
    containerSx,
    className,
    valueClassName,
    cardClassName,
    children
}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ...containerSx }} className={className}>
            <Box className={`audit-report-card ${cardClassName || ''}`.trim()} sx={{ width: '100%' }}>
                <Box className="audit-report-card-header">
                    <Typography className="audit-report-card-title">
                        {title}
                    </Typography>
                </Box>
                <Box className="audit-report-card-body">
                    <Box className="audit-report-card-content">
                        {isLoading ? (
                            <div className={`audit-skeleton skeleton-card-value ${!subtext ? 'margin-bottom' : ''}`} />
                        ) : (
                            <Box className={`audit-report-card-value ${valueClassName || ''}`}>
                                {value}
                            </Box>
                        )}
                        {subtext !== undefined && (
                            isLoading ? (
                                <div className="audit-skeleton skeleton-small-text" style={{ width: '80px', margin: '4px auto 0' }} />
                            ) : (
                                <Box className="audit-report-card-subtext">
                                    {subtext}
                                </Box>
                            )
                        )}
                        {!isLoading && extraContent ? (
                            <Box className="audit-report-card-extra">
                                {extraContent}
                            </Box>
                        ) : null}
                    </Box>
                    {footer && (
                        <Box className="audit-report-card-divider">
                            <Typography className="audit-report-card-footer">
                                {footer}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
            {!isLoading && children}
        </Box>
    );
};

export default SummaryTile;
